import './stepperStyles.css'
import { Button } from '@atd/rui-base.mui.button'
import { Stepper } from '@atd/rui-base.mui.stepper'
import { Step } from '@atd/rui-base.mui.step'
import { StepContent } from '@atd/rui-base.mui.step-content'
import { StepLabel } from '@atd/rui-base.mui.step-label'
import ValidatedTextField from '../commonComponents/validatedTextField'

import * as workorderActions from './workorderActions'


import JobDetailsBar from './dispatch/jobDetailsBar'
import React from 'react'
import WorkorderGFF from '../gffManager/gffDetails'
import WorkorderRates from '../productManager/rateReview'
import WorkorderScoutFeatures from '../scoutManager/scoutFeatureMapLazy'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { getHost } from '../lib/redirect'
import CleanTooltip from '../lib/cleanTooltip'

const styles = {
    defaultContentcolor: {
        backgroundColor: 'rgba(234,234,234, 0.25)',
    },
    iconStyle: {
        position: 'absolute',
        zIndex: 5,
        paddingLeft: '5px',
    },
}

const stepValues = {
    WO_NAME: 0,
    GFF_SELECTION: 1,
    PRODUCT_INFO: 2,
    SCOUT_FEATURES: 3,
    JOB_FILES: 4,
    TIME_STAMPS: 5,
    ASSIGNMENTS_AND_PARTICIPANTS: 6,
}

function mapStateToProps(state, ownProps) {
    return {
        selectedCompanyId: state.admin.selectedCompanyId,
        fileTypes: state.admin.fileTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(workorderActions, dispatch),
    }
}

class WorkorderStepper extends React.Component {
    state = {
        saved: true,
        products: [],
        error: null,
        name: '',
        associatedFiles: [],
        jobReportAvailable: false,
        openSteps: [],
        assignments: [],
        participants: [],
    }

    componentDidMount() {
        this.load()
    }

    componentDidUpdate(prevProps) {
        // When the selected company changes we need to reload base information
        // or clear the state to prevent the user from viewing a workorder
        // they don't have access to
        if (this.props.selectedCompanyId !== prevProps.selectedCompanyId) {
            this.load()
        }
    }
    getDisabled = () => {
        return !this.props.selectedCompanyId
    }
    load = () => {
        this.props.loadWorkorderDetails(this.props.existingWorkorderId).then(
            woDetails => {
                if (!woDetails.error) {
                    this.setState({
                        ...woDetails,
                        ...woDetails.metadata,
                        error: null,
                        createdTimestamp: format(woDetails.createdTime, 'yyyy-MM-dd HH:mm'),
                        startedTimestamp: woDetails.startedTime != null ? format(woDetails.startedTime, 'yyyy-MM-dd HH:mm') : '',
                        releasedTimestamp: woDetails.releasedTime != null ? format(woDetails.releasedTime, 'yyyy-MM-dd HH:mm') : '',
                        dispatchedTimestamp: woDetails.dispatchedTime != null ? format(woDetails.dispatchedTime, 'yyyy-MM-dd HH:mm') : '',
                        completedTimestamp: woDetails.completedTime != null ? format(woDetails.completedTime, 'yyyy-MM-dd HH:mm') : '',
                        archivedTimestamp: woDetails.archivedTime != null ? format(woDetails.archivedTime, 'yyyy-MM-dd HH:mm') : '',
                        updatedTimestamp: format(woDetails.updatedTime, 'yyyy-MM-dd HH:mm'),
                    })
                    this.loadAssignmentsAndParticipants(woDetails.guid)
                }
                else {
                    this.setState({error: woDetails.message})
                }
            },
        )
        this.props.loadWorkorderAssociatedFiles(this.props.existingWorkorderId).then(
            woFiles => {
                if (!woFiles.error && Array.isArray(woFiles)) {
                    this.setState({
                        associatedFiles: woFiles,
                    })
                }
            },
        )
        this.props.loadWorkorderApplicationFiles(this.props.existingWorkorderId).then(
            files => {
                if (!files.error && Array.isArray(files) && files.length > 0) {
                    this.setState({
                        jobReportAvailable: true,
                    })
                }
            },
        )
        this.setState({
            openSteps: [
                stepValues.WO_NAME,
                stepValues.GFF_SELECTION,
                stepValues.PRODUCT_INFO,
                stepValues.SCOUT_FEATURES,
                stepValues.JOB_FILES,
            ],
        })
    }
    loadAssignmentsAndParticipants = (guid) => {
        if (!guid) {
            return
        }
        this.props.loadWorkorderAssignments(guid).then(
            assignments => {
                if (!assignments.error && Array.isArray(assignments)) {
                    this.setState({
                        assignments: assignments,
                    })
                }
            },
        )
        this.props.loadWorkorderParticipants(guid).then(
            participants => {
                if (!participants.error && Array.isArray(participants)) {
                    this.setState({
                        participants: participants,
                    })
                }
            },
        )
    }
    renderAssociatedFiles = () => {
        let fileContent
        if (!this.state.associatedFiles || !this.state.associatedFiles.length) {
            fileContent = <span>{`No associated Files`}</span>
        }
        else {

            fileContent = (
                <table style={{width: '100%', paddingBottom: 20}}>
                    <tbody>
                        {this.state.associatedFiles.map(this.renderFileLine)}
                    </tbody>
                </table>
            )
        }

        return fileContent
    }
    renderAssignments = () => {
        let content
        if (!this.state.assignments || !this.state.assignments.length) {
            content = <span style={{marginLeft: 15}}>{`No assignments`}</span>
        }
        else {
            content = (
                <table style={{paddingBottom: 20}}>
                    <thead>
                        <tr>
                            <th style={{textAlign: 'left', paddingRight: 25}}>Hardware</th>
                            <th style={{textAlign: 'left', paddingRight: 25}}>Priority</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.assignments.map((data, i) => (
                            <tr key={`Assignment-${i}`}>
                                <td style={{paddingRight: 25}}>{data.hardwareName}</td>
                                <td style={{paddingRight: 25}}>{data.priority}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )
        }

        return (
            <div>
                <div style={{fontWeight: 'bold'}}>Assignments</div>
                {content}
            </div>
        )
    }
    renderParticipants = () => {
        let content
        if (!this.state.participants || !this.state.participants.length) {
            content = <span style={{marginLeft: 15}}>{`No participants`}</span>
        }
        else {
            content = (
                <table style={{paddingBottom: 20}}>
                    <thead>
                        <tr>
                            <th style={{textAlign: 'left', paddingRight: 25}}>Name</th>
                            <th style={{textAlign: 'left', paddingRight: 25}}>System ID</th>
                            <th style={{textAlign: 'left', paddingRight: 25}}>Updated</th>
                            <th style={{textAlign: 'left', paddingRight: 25}}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.participants.map((data, i) => (
                            <tr key={`Participant-${data.id ?? i}`}>
                                <td style={{paddingRight: 25}}>{data.name}</td>
                                <td style={{paddingRight: 25}}>{data.systemId}</td>
                                <td style={{paddingRight: 25}}>{data.updatedTime ? format(new Date(data.updatedTime), 'yyyy-MM-dd HH:mm') : ''}</td>
                                <td style={{paddingRight: 25}}>{data.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )
        }

        return (
            <div>
                <div style={{fontWeight: 'bold'}}>Participants</div>
                {content}
            </div>
        )
    }
    renderFileLine = (data, i) => {
        const fileType = this.props.fileTypes.find(f => f.id == data.fileTypeId)
        let displayName = data.name || data.id
        if (fileType && fileType.hasDetailView) {
            // we are feature flagging the new rx map file viewer with the conversion flag
            const href = data.fileTypeId === 4 && !fileType.requiresConversion ? `/jobs/rxmap/${data.id}` : `https://${getHost()}/index.php?r=fileMgmt/viewFile&id=${data.id}`

            displayName = <a
                href={href}
                target={`File_${data.id}`}
            >
                {displayName}
            </a>
        }

        return (
            <tr key={`File-${i}`}>
                <td>
                    {displayName}
                </td>
                <td>{fileType ? fileType.typeName : 'Unknown'}</td>
            </tr>
        )
    }
    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case stepValues.WO_NAME:
                return (
                    <div name="nameSection" className="stepContent-Indented">
                        <ValidatedTextField
                            label="Job Name"
                            fullWidth={true}
                            value={this.state.name}
                            disabled={this.state.saved}
                            name="nameEntry"
                        />
                    </div>
                )
            case stepValues.GFF_SELECTION:
                return (
                    <div name="gffSectionContent" className="stepContent-Indented">
                        <WorkorderGFF disabled={this.state.saved} grower={this.state.grower} farm={this.state.farm} field={this.state.field}/>
                    </div>
                )
            case stepValues.PRODUCT_INFO:
                return (
                    <div name="productSectionContent" className="stepContent-Indented">
                        <label>
                            NOTE: This page reflects the job as it was generated.
                            Mix content may have since been updated.
                        </label>
                        <WorkorderRates disabled={this.state.saved} products={this.state.products}/>
                    </div>
                )
            case stepValues.SCOUT_FEATURES:
                return (
                    <div name="scoutSectionContent">
                        <ValidatedTextField className="stepContent-Indented"
                            value={`${this.state.fieldDisplayArea} ${this.state.fieldAreaDisplayUnit}`}
                            disabled={this.state.saved}
                            label={'Field Area'}
                            fullWidth={true}
                            name="fieldArea"
                        />
                        <WorkorderScoutFeatures
                            interactive={this.state.saved}
                            style={{top: '-15px'}}
                        />
                    </div>
                )
            case stepValues.JOB_FILES:
                return (
                    <div name="jobFilesSectionContent">
                        <div className="stepContent-Indented">
                            {this.renderAssociatedFiles()}
                        </div>
                    </div>
                )
            case stepValues.TIME_STAMPS:
                return (
                    <div name="timeStampsSectionContent">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <CleanTooltip title="When the job record was created.">
                                            <div>Created:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.createdTimestamp}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CleanTooltip title="The earliest session start time.">
                                            <div>Started:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.startedTimestamp}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CleanTooltip title="A job must be released before it can be started.">
                                            <div>Released:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.releasedTimestamp}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CleanTooltip title="When the job was assigned to a machine or auto-dispatched.">
                                            <div>Dispatched:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.dispatchedTimestamp}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CleanTooltip title="The session end time of the session the job was marked completed in.">
                                            <div>Completed:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.completedTimestamp}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CleanTooltip title="When the job was archived - either manually, due to being completed, or a field computer originated job that was auto-archived.">
                                            <div>Archived:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.archivedTimestamp}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CleanTooltip title="When the data within the job was last modified.">
                                            <div>Last Updated:</div>
                                        </CleanTooltip>
                                    </td>
                                    <td>
                                        <div className="timestamp">{this.state.updatedTimestamp}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
            case stepValues.ASSIGNMENTS_AND_PARTICIPANTS:
                return (
                    <div name="assignmentsAndParticipantsSectionContent">
                        <div className="stepContent-Indented">
                            {this.renderAssignments()}
                            {this.renderParticipants()}
                        </div>
                    </div>
                )
            default:
                return '404: Page not found - stepper out of bounds'
        }
    }
    renderStep = (stepLabel, stepValue) => {
        return (
            <Step active={this.state.openSteps.includes(stepValue)} className="stepperStep">
                <StepLabel
                    sx={{ '& .MuiStepLabel-iconContainer': styles.iconStyle }}
                    name={`${stepLabel}-Label`}
                    className="stepHeader"
                >
                    <Button variant="contained"
                        fullWidth
                        // TODO(APPS-2833 stepper MR): drop paddingLeft once Stepper migrates to v5 — compensates for absolute-positioned step icon
                        sx={{textAlign: 'left', paddingLeft: '40px', justifyContent: 'flex-start'}}
                        color="secondary"
                        name={`${stepLabel}-StepButton`}
                        onClick={() => {
                            if (!this.state.openSteps.includes(stepValue)) {
                                this.setState({ openSteps: [...this.state.openSteps, stepValue]})
                            }
                            else {
                                this.setState({ openSteps: this.state.openSteps.filter(value => value !== stepValue) })
                            }
                        }}
                    >
                        {stepLabel}
                    </Button>
                </StepLabel>
                <StepContent>{this.getStepContent(stepValue)}</StepContent>
            </Step>
        )
    }
    render() {
        if (this.props.existingWorkorderId && this.state.originationId == 'FC' && !this.state.cloudJob) {
            throw new Error('Cannot show as-applied job as pre-populated job details')
        }

        if (this.state.error) {
            return (
                <label>{this.state.error}</label>
            )
        }

        return (
            <div
                className="stepper"
                name="verticalStepper"
            >
                <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: 5}}>
                    <div style={{flexGrow: 1}}>{`Created: ${this.state.createdTimestamp}`}</div>
                    <div style={{flexGrow: 1}}>{`Last Update: ${this.state.updatedTimestamp}`}</div>
                </div>
                <Stepper
                    nonLinear
                    orientation="vertical"
                    style={styles.defaultContentcolor}
                >
                    {this.renderStep('Job Name', stepValues.WO_NAME)}
                    {this.renderStep('Grower, Farm, Field', stepValues.GFF_SELECTION)}
                    {this.renderStep('Product Config', stepValues.PRODUCT_INFO)}
                    {this.renderStep('Field Information', stepValues.SCOUT_FEATURES)}
                    {this.renderStep('Associated Files', stepValues.JOB_FILES)}
                    {this.renderStep('All Timestamps', stepValues.TIME_STAMPS)}
                    {this.renderStep('Assignments and Participants', stepValues.ASSIGNMENTS_AND_PARTICIPANTS)}
                </Stepper>
                <JobDetailsBar
                    jobReportAvailable={this.state.jobReportAvailable}
                    archived={this.state.archived}
                    disabled={this.getDisabled()}
                    releasedTime={this.state.releasedTime}
                    workorderId={this.state.id}
                    onArchiveChanged={this.load}
                    workorderGuid={this.state.guid}
                    ownerPartyId={this.state.ownerPartyId}
                    selectedCompanyId={this.props.selectedCompanyId}

                />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkorderStepper)
